import { META_IMAGES, OG_IMAGES } from '@/v2/constants/images/meta'
import { AUTH_ROUTES, PUBLIC_MAIN_ROUTES } from '@/v2/constants/routes'
import { OGImageType } from '@/v2/types/meta'

export const ogImages: OGImageType[] = [
  {
    url: OG_IMAGES.BASE_URL.concat('/international-shipping-services.jpg'),
    alt: 'international shipping services page og',
    width: 1200,
    height: 630
  }
]

export const metaImages: OGImageType[] = [
  {
    url: META_IMAGES.DEFAULT,
    alt: 'international shipping services page search image',
    width: 92,
    height: 92
  },
  ...ogImages
]

export const heroSectionContent = {
  title: 'Seamless <span>International</span> <span>Shipping Services</span',
  description:
    "Shipping items across borders shouldn't be a hassle. At ShipAndStorage, we simplify international shipping by offering reliable, affordable, and tailored solutions for individuals and businesses. ",
  image: {
    url: '/images/v2/pages/main-pages/international-shipping-services/hero-image.jpg',
    alt: 'international shipping services page'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Start Shipping' }
}

export const howOurInternationalShippingServicesWork = {
  title: 'How Our International Shipping Services Work',
  ctaButton: { href: PUBLIC_MAIN_ROUTES.BOOK_STORAGE_FACILITY.href, text: 'Ship Anywhere' },

  cards: [
    {
      id: 1,
      title: 'Get an Instant Quote',
      description:
        'Provide shipment details such as destination, size, and weight to receive a tailored quote instantly.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/get-an-instant-quote.svg',
        alt: 'Get an Instant Quote service'
      }
    },
    {
      id: 2,
      title: 'Prepare Your Shipment',
      description: 'Select a pickup or drop-off option, and package your items securely to ensure safe transit.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/prepare-your-shipment.svg',
        alt: 'Prepare Your Shipment service'
      }
    },
    {
      id: 3,
      title: 'Track Your Delivery',
      description: 'Follow your shipment with real-time tracking updates and receive confirmation upon delivery.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/track-your-delivery.svg',
        alt: 'Track Your Delivery service'
      }
    }
  ]
}

export const whyChooseUsSectionContent = {
  title: 'Why Choose Our International Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Global Reach',
      description:
        'Ship to over 220 countries and territories with ease, ensuring your packages reach their destinations efficiently & on time.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/global-reach.svg',
        alt: 'Global Reach service'
      }
    },
    {
      id: 2,
      title: 'Customs Assistance',
      description:
        'We navigate the complexities of customs documentation and clearance, saving you time and ensuring smooth transit.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/customs-assistance.svg',
        alt: 'Customs Assistance service'
      }
    },
    {
      id: 3,
      title: 'Affordable Rates',
      description:
        'Enjoy competitive pricing without compromising on quality, with options to match every budget and shipping need.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/affordable-rates.svg',
        alt: 'Affordable Rates service'
      }
    },
    {
      id: 4,
      title: 'Advanced Tracking',
      description:
        'Track your shipment every step of the way with real-time updates, ensuring peace of mind and transparency.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/advanced-tracking.svg',
        alt: 'Advanced Tracking service'
      }
    },
    {
      id: 5,
      title: 'Flexible Solutions',
      description:
        'Choose from express, standard, or economy shipping options tailored to your timeline and budget requirements.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/flexible-solutions.svg',
        alt: 'Flexible Solutions service'
      }
    },
    {
      id: 6,
      title: 'Reliable Delivery Times',
      description:
        'We provide reliable and predictable delivery schedules, so you can count on your packages arriving when you expect. ',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/reliable-delivery-times.svg',
        alt: 'Reliable Delivery Times service'
      }
    }
  ]
}

export const whyWeSectionContent = {
  title: 'How We Stand Out for International Shipping Services',

  cards: [
    {
      id: 1,
      title: 'Door-to-Door Delivery',
      description:
        'Convenient pickup and delivery options save you the hassle of drop-offs and pickups at distant locations.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/door-to-door-delivery.svg',
        alt: 'Door-to-Door Delivery service'
      }
    },
    {
      id: 2,
      title: 'Package Consolidation',
      description:
        'Save on shipping costs by combining multiple packages into one, reducing overall weight and dimensional fees.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/package-consolidation.svg',
        alt: 'Package Consolidation service'
      }
    },
    {
      id: 3,
      title: 'Custom Packaging Services',
      description:
        'Our high-quality packaging materials ensure your items remain secure and intact throughout their journey.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/custom-packaging-services.svg',
        alt: 'Custom Packaging Services service'
      }
    },
    {
      id: 4,
      title: 'Insurance Options',
      description:
        'Opt for comprehensive coverage for valuable or fragile items, offering added protection during transit.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/insurance-options.svg',
        alt: 'Insurance Options service'
      }
    }
  ]
}

export const partnersSectionContent = {
  title: 'International Shipping Carriers',

  cards: [
    {
      id: 1,
      title: 'DHL',
      description:
        'DHL offers fast international deliveries to over 220 countries, ensuring reliable service for urgent shipments.',
      image: {
        src: '/images/v2/pages/main-pages/common/dhl.svg',
        alt: 'DHL'
      }
    },
    {
      id: 2,
      title: 'FedEx',
      description:
        'FedEx provides options like International Priority & Economy, balancing cost-efficiency with prompt global delivery.',
      image: {
        src: '/images/v2/pages/main-pages/common/fedEx.svg',
        alt: 'FedEx'
      }
    },
    {
      id: 3,
      title: 'UPS',
      description:
        'UPS specializes in secure international shipping with diverse services, including Worldwide Saver and Expedited options.',
      image: {
        src: '/images/v2/pages/main-pages/common/ups.svg',
        alt: 'UPS service'
      }
    }
  ]
}

export const keyFactorsAffectingSectionContent = {
  title: 'Key Factors Affecting International Shipping Rates',

  articles: [
    {
      content: [
        {
          title: 'Weight and Dimensions',
          description:
            'Heavier and oversized luggage results in higher shipping fees due to additional handling and space requirements.'
        },
        {
          title: 'Shipping Destination',
          description:
            'Rates vary based on the distance and specific destination zones, impacting delivery time and cost.'
        },
        {
          title: 'Delivery Speed',
          description:
            'Expedited options like express delivery cost more compared to standard or economy shipping services.'
        }
      ],
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/key-factors-affecting-international-shipping-rates.svg',
        alt: 'Key Factors Affecting International Shipping Rates'
      },
      link: { href: PUBLIC_MAIN_ROUTES.HOW_SHIP_AND_STORAGE_WORKS.href, text: 'Calculate Shipping Costs' }
    }
  ]
}

export const forWhoSectionContent = {
  title: 'What Can You Ship Internationally with ShipAndStorage?',

  cards: [
    {
      id: 1,
      title: 'Personal Luggage',
      description:
        'Send suitcases, duffle bags, and backpacks for vacations, relocations, or business trips without any hassle.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/personal-luggage.svg',
        alt: 'Personal Luggage service'
      }
    },
    {
      id: 2,
      title: 'Household Items',
      description: 'Ship items like linens, small appliances, books, and decor to family or your new home overseas.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/household-items.svg',
        alt: 'Household Items service'
      }
    },
    {
      id: 3,
      title: 'Sports Equipment',
      description:
        'Transport skis, snowboards, golf clubs, and bicycles hassle-free to your international adventure destination.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/sports-equipment.svg',
        alt: 'Sports Equipment service'
      }
    },
    {
      id: 4,
      title: 'Business Materials',
      description: 'Send promotional items, documents, or trade show equipment to global clients or events right away.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/business-materials.svg',
        alt: 'Business Materials service'
      }
    },
    {
      id: 5,
      title: 'Electronics',
      description: 'Safely ship laptops, cameras, and gaming consoles with custom packaging and insurance options.',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/electronics.svg',
        alt: 'Electronics service'
      }
    },
    {
      id: 6,
      title: 'Specialty Items',
      description:
        'From artwork to musical instruments, we handle fragile and unique items with extra care and security. ',
      image: {
        src: '/images/v2/pages/main-pages/international-shipping-services/specialty-items.svg',
        alt: 'Specialty Items service'
      }
    }
  ]
}

export const promotionalBannerSectionContent = {
  id: 1,
  title: 'Ready to Ship Internationally?',
  description:
    'Experience hassle-free global shipping with ShipAndStorage. Get a free quote today and start your journey with us!',
  image: {
    src: '/images/v2/pages/main-pages/international-shipping-services/promotional-banner-image.svg',
    alt: 'Ready to Ship Internationally?'
  },
  ctaButton: { href: AUTH_ROUTES.REGISTER.href, text: 'Book Your Shipment' }
}

export const faqSectionContent = {
  title: 'Frequently Asked Questions',

  questions: [
    {
      id: 1,
      question: 'How are international shipping costs calculated?',
      answer:
        'Costs depend on factors like weight, dimensions, destination, shipping speed, and additional services like insurance.'
    },
    {
      id: 2,
      question: 'What documents are required for international shipping?',
      answer:
        'Typically, you’ll need a commercial invoice, shipping label, and customs declaration. We provide guidance to simplify the process.'
    },
    {
      id: 3,
      question: 'Can I ship fragile or valuable items internationally?',
      answer: ' Yes, we offer special packaging and insurance options to protect your valuable or delicate items.'
    },
    {
      id: 4,
      question: 'How long does international shipping take?',
      answer: ' Delivery times vary by carrier and service, ranging from 1–3 days for express to 7–14 days for economy.'
    },
    {
      id: 5,
      question: 'Do you offer tracking for international shipments?',
      answer: 'Yes, all our international shipments come with real-time tracking to keep you informed.'
    }
  ]
}
